import classnames from 'classnames/bind';
import { FC } from 'react';
import { ApprovalGroupItemProps } from '../../types';
import { ApproverInformation } from '../ApproverInformation';
import { ApprovalGroupTitle } from '../AprovalGroupTitle';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

export const ApprovalGroupItem: FC<ApprovalGroupItemProps> = ({
  groupItem,
  isShowInformationTag,
}) => {
  if (!groupItem) {
    return null;
  }
  return (
    <div className={cx('container')}>
      <ApprovalGroupTitle
        condition={groupItem.condition}
        isShowInformationTag={isShowInformationTag}
        groupName={groupItem.name}
      />
      {groupItem.approvals &&
        groupItem.approvals.map((approval) => (
          <ApproverInformation
            key={approval.approver_display_name}
            approver={approval}
          />
        ))}
    </div>
  );
};
